import React, { useEffect, useState } from 'react';
import { ActivityIndicator, View } from "react-native"
import { useDispatch, useSelector } from 'react-redux';
import Colors from '../../../constants/Colorsv2';
import { Text, TouchableOpacity } from "../../../globalComponents/NativeOverrides"
import { BestAvailableOrderProps, MarketProps, MarketSideOptionProps, TradeProps } from "../../../store/types/mk_svc"
import { PlayerPickProps } from '../../../store/types/tp_svc';
import { market_getOddsLabel, market_getVar1Label } from '../helpers/markets';
import { trade_getTradeFromAvailableOrder, trade_getTradeFromMarket } from "../helpers/trades"
import OrderGradeBar from '../../../Componentsv1/OrderGradeBar';
import { V1_LOAD_EXTERNAL_PRICE_COMPARISON } from '../../../store/actionsv1/types';


type MarketCardProps = {
    event_id:string,
    event_type: 'match'|'tournament'|'team',
    side_array:{ side:string, side_id:string }[]
    market: MarketProps
    source?:'market'|'competition_create'|'competition_play',
    pick?:PlayerPickProps;
    onPress: (trade:TradeProps) => void;
    align: 'vertical'|'horizontal';
    trades_override?:TradeProps[]
}

const grade_boxes = [
    { min: 0, max: 79, success_color: 'rgba(125,205,133,0.2)', fail_color: 'rgba(213,87, 59, 0.2)', locked_color: Colors.shades.shade100 },
    { min: 80, max: 94, success_color: 'rgba(125,205,133,0.4)', fail_color: 'rgba(213,87, 59, 0.4)', locked_color: Colors.shades.shade100 },
    { min:95, max: 97.5, success_color: 'rgba(125,205,133,0.6)', fail_color: 'rgba(213,87, 59, 0.6)', locked_color: Colors.shades.shade100 },
    { min:97.6, max: 99.99, success_color: 'rgba(125,205,133,0.8)', fail_color: 'rgba(213,87, 59, 0)', locked_color: Colors.shades.shade100 },
    { min: 100, max: 200, success_color: 'rgba(125,205,133,1)', fail_color: 'rgba(213,87, 59, 0)', locked_color: Colors.shades.shade100 }
]


const MarketCard = ({ market, source, side_array, event_id, event_type, align, pick, onPress, trades_override }:MarketCardProps) => {
    const [ loaded, setLoaded ] = useState(false);
    const [ loading, setLoading ] = useState(false);
    //Force the trade side to always be on the bottom or right
    const side_options = [market.side_options.find(o => o.side !== market.trade_side)??'', market.side_options.find(o => o.side === market.trade_side)]
    const market_type:string = useSelector((state:any) => state.auth.market_type, (left, right) => left == right)
    const dispatch = useDispatch();
    const default_lines:'best_available'|'last_trade'|undefined = useSelector((state:any) => state.auth.default_lines, (left, right) => left == right);
    let line_type = market_type == 'FOR_MONEY' ? default_lines : 'last_trade';
    const best_available_list: BestAvailableOrderProps[] | undefined = useSelector((state:any) => state.market.best_available[`${event_type}:${event_id}`], (left, right) => left == right);
    let best_available:BestAvailableOrderProps[] = []
    if(best_available_list){
        best_available = best_available_list.filter(ba => ba.market_id == market.market_id  && ba.show && side_array.map(a => a.side_id.toString()).includes(ba.side_id.toString()))
    }

    const latest_trades_list: TradeProps[] | undefined = useSelector((state:any) => state.market.latest_trades[`${event_type}:${event_id}`], (left, right) => left == right);
    let trades:TradeProps[] = []
    if(latest_trades_list){ trades = latest_trades_list.filter(t => t.market_type == market_type && t.market_id == market.market_id) }
    useEffect(() => {
        setLoaded(true);
    },[])

    useEffect(() => {
        if(!loaded){ return }//Dont do anything
        if(source != 'market'){ return } //Dont do anything for competitions
        if(default_lines == 'best_available'){
            setLoading(true)
            setTimeout(() => {
                setLoading(false)
            }, 750);
        }
    },[best_available[0]?.order_id, best_available[1]?.order_id])


    if(event_id == '86781' && market.market_id == '2'){
        console.log(best_available)
    }

    const handlePress = (side:MarketSideOptionProps, trade?:TradeProps) => {
        let found_side = side_array.find(ids => ids.side === side.side)
        if(!found_side?.side_id){ return } //Didn't get passed the correct info
        if(!onPress){ return } //In case the parent does not pass down a handling function
        //let trade = trades.find(t => t.side === side.side && t.side_id == found_side.side_id)
        //if(trades_override){
        //    trade = trades_override.find(t => t.side === side.side && t.market_id == market.market_id)
        //}
        if(!trade){
            trade = { ...trade_getTradeFromMarket(market, found_side.side, found_side.side_id, event_id, event_type), limit_override: true }
        }
        trade = { ...trade, side_id: side_array.find(sa => sa.side == trade.side)?.side_id??'' }
        onPress(trade)
    }

    const handleLongPress = (side_option:MarketSideOptionProps, side_id:string) => {
        dispatch({ 
            type: V1_LOAD_EXTERNAL_PRICE_COMPARISON, 
            external_price_comparison: {
                event_id,
                event_type,
                init_market:market,
                side: side_option.side,
                participant_id: market.level != 'event' ? side_id : undefined,
                participant_type: side_option.id_source
            } 
        })
    }

    /**
     * If a pick object is included, then we need to highlight the picked side based on the result
     * @param pick 
     * @returns 
     */
    const getPickHighlightColor = (pick?:PlayerPickProps) => {
        if(!pick){ return Colors.shades.shade600 }
        switch(pick.result_ind){
            case 'win': return Colors.utility.success
            case 'lose': return Colors.utility.error
            case 'draw': return Colors.brand.slate
            default: return Colors.highlights.highlight200
        }
    }

    const getButtonColor = (line_view:'best'|'trade', highlighted:boolean, pick?:PlayerPickProps) => {
        if(highlighted){
            return getPickHighlightColor(pick)
        }
        if(source != 'market'){ return Colors.shades.shade600 }
        if(trades_override){ return Colors.shades.shade600 }//Trades override will always send shade600
        if(line_type == 'best_available'){
            if(line_view == 'best'){ return Colors.highlights.highlight500Faded }
            return Colors.shades.shade200
        }
        //Default lines is set to last trade
        return Colors.shades.shade600
    }

    /**
     * Render the sides.  If there is a trade, then overlay with the trade details
     * @param data 
     * @returns 
     */
    const renderSides = (data: { item:MarketSideOptionProps, index:number }) => {
        let line_view:'trade'|'best' = 'trade'
        const highlight = pick?.side == data.item.side ? true : false
        let side_id = side_array.find(a => a.side === data.item.side)?.side_id
        if(!side_id){ return <></> }
        let liquidity = 0
        let trade:TradeProps|undefined = undefined;
        let available_order:BestAvailableOrderProps | undefined = undefined
        //If there is a trades override - that is always shown
        if(trades_override){
            trade = trades_override.find(t => t.side == data.item.side && t.side_id == side_id && t.market_id == market.market_id)
        } else {
            //If no trades override - we will adhear to the default lines setting if it is set to best_available
            if(source=='market' && line_type == 'best_available'){
                let avail_orders = best_available.filter(o => o.side == data.item.side && o.side_id == side_id && o.show);
                available_order = avail_orders.sort((a,b) => a.probability - b.probability)[0]

                //available_order = best_available.find(o => o.side == data.item.side && o.side_id == side_id && o.show);
                if(available_order){
                    trade = trade_getTradeFromAvailableOrder(available_order)
                    liquidity = available_order.open_amt;
                    line_view = 'best'
                } else {
                    //Check was there an order for the other side?
                    let o_side_order = best_available.find(o => o.side != data.item.side && o.show);
                    if(!o_side_order){
                        //Was there one on the opposite side?
                        trade = trades.find(t => t.side == data.item.side && t.side_id == side_id)
                        line_view = 'trade'
                    } else {
                        trade = { ...trade_getTradeFromMarket(market, data.item.side, side_id, event_id, event_type), limit_override: true, var_1: o_side_order.var_1, odds:o_side_order.odds * -1, probability:1 - o_side_order.probability }
                        if(market.type == 'Spread'){
                            trade.var_1 = trade.var_1 * -1
                        }
                    }
                }
            } else {
                trade = trades.find(t => t.side == data.item.side && t.side_id == side_id)
                line_view = 'trade'
            }
        }

        
        const text_color = highlight ? Colors.shades.white : Colors.shades.black
        return (
            <TouchableOpacity 
                disabled={loading} 
                key={data.item.side} 
                native_id={`${data.item.side}:${market.market_id}`}
                style={{flex:1, minHeight:40, borderRadius:4, padding:4, backgroundColor: getButtonColor(line_view, highlight, pick), justifyContent:'center', alignItems:'center', margin:4 }}
                onPress={() => handlePress(data.item, trade, liquidity)}
                onLongPress={() => handleLongPress(data.item, side_id)}
            >
                <View>
                    {loading ?
                    <ActivityIndicator size='small' color={Colors.shades.white} style={{ alignSelf:'center' }} />
                    :
                    <View>
                        {trade ?
                        <View style={{ justifyContent:'center', alignItems:'center' }}>
                            {market.var_1_required ?
                            <Text size={12} color={text_color} textAlign='center'>{market.show_side_option?`${data.item.label.toUpperCase()} `:''}{market_getVar1Label(trade.var_1, market)}</Text>
                            :market.show_side_option ?
                            <Text size={12} color={text_color} textAlign='center'>{data.item.label.toUpperCase()}</Text>
                            :<></>}
                            
                            <Text size={12} color={text_color} weight='bold' textAlign='center'>{market_getOddsLabel(trade.odds)}</Text>
                        </View>
                        :
                        <View>
                            {market.var_1_required ?
                            <Text size={12} color={text_color} textAlign='center'>{market.show_side_option?`${data.item.label.toUpperCase()} `:''}</Text>
                            :<></>}
                            <View>
                                <Text size={12} color={text_color} textAlign='center'>{data.item.label.toUpperCase()}</Text>
                            </View>
                        </View>
                        }
                    </View>
                    }
                </View>
                {line_view == 'best' && available_order ?
                <View style={{position:'absolute', bottom:0, left:5, right:5, height:2}}>
                    <OrderGradeBar 
                        view_type='market'
                        grade={available_order.grade}
                    />
                </View>
                :<></>}
            </TouchableOpacity>
        )
    }
    return (
        <View style={{ flex:1, flexDirection:align==='horizontal'?'row':'column' }}>
            {side_options.map((o, index) => {
                return renderSides({ item:o, index })
            })}
        </View>
    )
}

export default MarketCard